<template>
  <div class="login-container">
    <div class="mascara">
      <div
        class="col-9 absolute-center"
      >
        <div class="col-12">
          <transition
            appear
            enter-active-class="animated slideInRight"
            leave-active-class="animated slideOutRight"
          >
            <section
              v-if="show"
              class="col-12"
            >
              <password-form />
            </section>
          </transition>
        </div>
      </div>
      <div class="absolute-bottom text-center q-mb-md">
        <img src="~assets/logoVeolia.png" class="veolia-logo" />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import PasswordForm from './PasswordForm'

@Component({
  name: 'password',
  components: {
    PasswordForm
  }
})
export default class Password extends Vue {
  show = true;
}
</script>
<style lang="stylus" scoped>
.login-container {
  width: 100%;
  background-image: url("~assets/backgroundLogin.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: calc(100vh - 0px);
  overflow-y: auto;
}

.mascara {
  width: 100%;
  height: 100%;
  background: rgba(57, 64, 83, 0.8);
}

.veolia-logo{
  width: 9%;
  opacity: 0.8;
}

@media only screen and (max-width: 1600px) {
  .bg-login {
    min-width: 55%!important;
  }
}
</style>
